/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react';
import { Close } from '@mui/icons-material';

import { Theme as MaterialTheme, useTheme, Dialog, DialogTitle, Typography, DialogContent, useMediaQuery, DialogActions, IconButton, TextField, Stack, Button, Backdrop, CircularProgress } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import { useState, useEffect, ChangeEvent } from "react";

import { useTranslation } from 'react-i18next';
import OrganizationBusinessLogic from '../../../businessLogic/OrganizationBusinessLogic';
import { toast } from 'react-toastify';

interface IDialogProps {
    open: boolean,
    closeDialog: () => void,
    organizationId: string,
    id?: number,
    postOrPut: "post" | "put",
    oldName?: string,
    oldAccount?: string,
    getCashRegisterPaymentMethods: () => void,

}

const DialogAddEditPaymentMethod = (props: IDialogProps): JSX.Element => {

    const { open, closeDialog, organizationId, postOrPut, id, oldName, oldAccount, getCashRegisterPaymentMethods } = props;

    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [loader, setLoader] = useState(false);

    const [newPaymentMethodName, setNewPaymentMethodName] = useState(oldName ? oldName : "");
    const [newPaymentMethodAccount, setNewPaymentMethodAccount] = useState(oldAccount ? oldAccount : "");

    useEffect(() => {
        setNewPaymentMethodName(oldName ? oldName : "")
        setNewPaymentMethodAccount(oldAccount ? oldAccount : "")
    }, [oldName, oldAccount])

    function validatePaymentmethod(): boolean {
        if (newPaymentMethodName !== "" && newPaymentMethodAccount !== "" && /^\d+(?:\.\d+)*$/.test(newPaymentMethodAccount)) {
            return true
        } else {
            toast(t("basic.paymentMethodInputError"))
            return false
        }
    }

    //###############################################################################################################################################
    //########################################################API Calls and useEffects###############################################################
    const postPaymentMethod = async () => {
        if (organizationId) {
            if (validatePaymentmethod()) {
                let logic = new OrganizationBusinessLogic();
                setLoader(true);
                const result = await logic.postCashRegisterPaymentMethod(organizationId, newPaymentMethodName, newPaymentMethodAccount.replaceAll(".", ""),);
                setLoader(false);
                if (result.hasErrors) {
                    toast(t("basic.errorDataSave"));
                } else {
                    getCashRegisterPaymentMethods();
                    closeDialog();
                    toast(t("basic.dataSaved"));

                }
            }
        }
    }
    const putPaymentMethod = async (id: number) => {
        if (organizationId) {
            if (validatePaymentmethod()) {
                let logic = new OrganizationBusinessLogic();
                setLoader(true);
                const result = await logic.putCashRegisterPaymentMethod(organizationId, id, newPaymentMethodName, newPaymentMethodAccount.replaceAll(".", ""),);
                setLoader(false);
                if (result.hasErrors) {
                    toast(t("basic.errorDataSave"));
                } else {
                    getCashRegisterPaymentMethods()
                    closeDialog();
                    toast(t("basic.dataSaved"));

                }
            }
        }
    }
    const postOrPutPaymentMethod = (id: number | undefined) => {
        if (postOrPut === "post") {
            postPaymentMethod();
        } else if(id) {
            putPaymentMethod(id);
        }
    }
    //########################################################################################
    //########################################################################################

    return <Dialog fullWidth
        onClose={(event, reason) => props.closeDialog}
        open={props.open}
        >

        <DialogTitle display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{postOrPut === "post" ? t("basic.create") : t("basic.change")}</Typography>
            <IconButton onClick={props.closeDialog}><Close /></IconButton>
        </DialogTitle>
        <DialogContent dividers>
            <Stack direction="column" spacing={4}>
                <TextField
                    fullWidth
                    //css={textBoxInputStyleActor(theme)}
                    size="small"
                    variant="outlined"
                    label={t("basic.name")}
                    color="warning"
                    value={newPaymentMethodName}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setNewPaymentMethodName(e.target.value)} />
                <TextField
                    fullWidth
                    //css={textBoxInputStyleActor(theme)}
                    size="small"
                    variant="outlined"
                    label={t("basic.accountId")}
                    type="number"
                    color="warning"
                    value={newPaymentMethodAccount}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setNewPaymentMethodAccount(e.target.value)} />
            </Stack>
        </DialogContent>
        <DialogContent>
            <Button onClick={() => postOrPutPaymentMethod(id)} fullWidth variant="contained">{t("basic.save")}</Button>
        </DialogContent>
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loader}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    </Dialog>
}
export default DialogAddEditPaymentMethod;